import clone from 'clone'
import { actions } from './actions'
import { getters } from './getters/getters'
import { mutations } from './mutations'

export const initialState = {
  // Agency level init (bring in menu for specific modules eg: travel motor etc)
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  journalListing: {
    init: 0,
    initErr: [],
    menu: {}
  },
  journal: {
    journalId: {
      tranMode: null,
      jrnlNo: null,
      status: null,
      statusDesc: null
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
